import { SelectOptionType } from '@octano/global-ui';
import { useCallback } from 'react';

import { getNonStructuredTeachersRequest } from '../../api/requests/sectionsMaintainer';

export const useSearchNonStructuredTeachers = () => {
  return useCallback(async (searchText: string): Promise<
    SelectOptionType[]
  > => {
    const { data } = await getNonStructuredTeachersRequest(searchText);
    if (data) {
      return data.map((teacher) => ({
        value: teacher.id,
        label: teacher.account?.fullName ?? '',
      }));
    }
    return [];
  }, []);
};
